import { ArrowLeftIcon, XMarkIcon } from "@heroicons/react/24/outline";
import PosCustomIcon from "../../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import "./HelpAndSupportNavBar.css";

const HelpAndSupportNavBar = ({ canGoBack = true, onBack, headder = "", subHeadder = "", onClose }) => {
  return (
    <section className="navbar-section-container">
      <div className="navbar-section-left-div">
        {canGoBack && (
          <PosCustomIcon
            icon={<ArrowLeftIcon />}
            height={"20px"}
            width={"20px"}
            marginTop={"-25px"}
            onClickFunction={onBack}
          />
        )}

        <div className="header-subHeader-div">
          <p className="headder-p">{headder}</p>
          <p className="subHeadder-p">{subHeadder}</p>
        </div>
      </div>

      <button
        className="button-support-close"
        onClick={onClose}
        data-testid="button-support-close"
      >
        <XMarkIcon />
      </button>
    </section>
  );
};

export default HelpAndSupportNavBar;
